<template>
  <div
    class="w-full bg-zt-white rounded-zt-md overflow-hidden"
    :class="[boxLogin.styles.shadow]"
    :style="[boxLogin.styles.box]"
  >
    <div class="flex flex-col items-center p-6">
      <div
        class="mb-4 flex justify-center h-full"
        :class="[boxLogin.sizeLogo === 'full' ? 'w-full' : 'w-56']"
      >
        <img class="format-img" :src="boxLogin.logoUrl" alt="" />
      </div>
      <div class="flex mt-4 justify-center h-full w-3/4 md:w-10/12">
        <div class="w-1/4 flex">
          <div class="my-auto">
            <div
              class="blue-circle h-16 w-16 md:h-24 md:w-24 rounded-full flex justify-center items-center"
            >
              <zt-icon
                class="m-auto text-white text-3xl md:text-5xl"
                name="shield-check"
              />
            </div>
          </div>
        </div>
        <div class="w-2/3 flex flex-wrap">
          <span
            class="text-zt-base md:text-zt-lg font-medium text-zt-primary-200 my-auto"
            >{{ $t('message.mfa.email_verification.title') }}</span
          >
          <p
            class="hidden md:flex md:mt-4 text-zt-dark-400"
            :style="[boxLogin.styles.form.textColor]"
          >
            {{ $t('message.mfa.email_verification.description') }}
          </p>
        </div>
      </div>
      <div class="flex md:hidden mt-4 justify-center h-full w-11/12">
        <p
          class="text-zt-dark-400 text-center"
          :style="[boxLogin.styles.form.textColor]"
        >
          {{ $t('message.mfa.email_verification.description') }}
        </p>
      </div>
      <div class="mt-4 w-10/12">
        <ValidationObserver v-slot="{ invalid }">
          <div class="mb-10 relative">
            <ValidationProvider
              rules="email|required|min:2"
              v-slot="{ invalid, errors }"
            >
              <zt-input
                outlined
                name="email"
                :label="$t('message.mfa.email_verification.input_label')"
                :style="[boxLogin.styles.form.inputs.bgColor]"
                :color="colorOutlineEmail(invalid)"
                v-model="email"
                @input="clearError"
                class="mt-12"
                data-vs-input="auth-mfa-emailverification-input-email"
              />
              <span class="text-zt-danger absolute left-0" v-show="errors[0]">{{
                $t('message.loginComponent.validations.emailRules.validMail')
              }}</span>
               <span class="text-zt-danger absolute left-0" v-show="associatedMail">{{
                $t('message.loginComponent.validations.emailRules.associatedMail')
              }}</span>
            </ValidationProvider>
          </div>
          <div class="mb-4 mt-10 flex justify-between">
            <div class="w-custom-buttons">
              <zt-button
                class="zt-button-login w-full opacity-100"
                outlined
                @click="gotoLogin"
                data-vs-button="auth-mfa-emailverification-btn-gotologin"
              >
                <span>
                  {{ $t('message.mfa.email_verification.go_back') }}
                </span>
              </zt-button>
            </div>
            <div class="w-custom-buttons">
              <zt-button
                class="zt-button-login w-full opacity-100"
                :style="[bgButtonColor(invalid)]"
                :disabled="invalid || isDisabledButton"
                @click="submitEmailVerification"
                data-vs-button="auth-mfa-emailverification-btn-submitemailvarification"
              >
                <span v-if="!isLoadingLogin">
                  {{ $t('message.mfa.email_verification.send') }}
                </span>
                <vue-loading
                  v-if="isLoadingLogin"
                  background-color="rgba(0,0,0,0.0)"
                  :active="isLoadingLogin"
                  color="#4F41A3"
                  :width="25"
                  :height="25"
                  :is-full-page="false"
                />
              </zt-button>
            </div>
          </div>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import loginCustomParams from '@/modules/Auth/mixins/loginCustomParams'
import User from '@/apiClient/Users'

export default {
  data() {
    return {
      objectLoginParams: {},
      isLoadingLogin: false,
      isDisabledButton: false,
      user: User,
      email: '',
      password: '',
      associatedMail:''
    }
  },
  mixins: [loginCustomParams],
  computed: {
    ...mapGetters({
      getLoginCustomParams: 'auth/getLoginCustomParams',
      getJwt: 'getJwt'
    }),
    bgButtonColor() {
      return invalid =>
        invalid
          ? { backgroundColor: '#E2E2E2' }
          : this.boxLogin.styles.form.buttons.bgColor
    },
    colorOutlineEmail() {
      return invalid =>
        invalid ? 'danger' : this.boxLogin.styles.form.inputs.outlineColor
    }
  },
  created() {
    if (!this.getJwt) {
      this.$router.push('/login')
    }
    this.user = new User()
    this.objectLoginParams = this.getLoginCustomParams.loginCustom
    if (this.$route.params.email) {
      this.email = this.$route.params.email
    }
    this.password = this.$route.params.password
  },
  methods: {
    clearError(){
      this.associatedMail = ''
    },
    gotoLogin() {
      this.$router.push({ name: 'login' })
    },
    submitEmailVerification() {
      this.isLoadingLogin = true
      this.isDisabledButton = true
      this.user
        .changeMail(this.password, this.email)
        .then(response => {
          this.isLoadingLogin = false
          this.isDisabledButton = false
          this.$router.push({
            name: 'mfaCodeVerification',
            params: { email: this.email }
          })
        })
        .catch(e => {
          this.isLoadingLogin = false
          this.isDisabledButton = false
          if (e.response.data.response_v2.code == '00074') {this.associatedMail = e.response.data.results.data[0]}
        })
    }
  }
}
</script>

<style scoped lang="scss">
.format-img {
  height: 100%;
  max-width: 100%;
  vertical-align: middle;
  width: 100%;
  -ms-interpolation-mode: bicubic;
  display: inline-block;
}
.blue-circle {
  background-color: #2196f3;
}
.w-custom-buttons {
  width: 45%;
}
</style>
